import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const RevalidationPromptModal = ({ show, onHide, setCurrentStep }) => {
  const navigate = useNavigate();

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
      <Modal.Body className="p-4 text-center">
        <div className="mb-3">
          <i className="bi bi-person-check fs-1 text-primary"></i>
        </div>
        <h5 className="fw-bold mb-2">Time to Review Your Profile</h5>
        <p className="text-muted mb-3">
          It has been a while since you last updated your details. Please take a moment to review and confirm your information. You can keep everything as-is or update if needed.
        </p>
        <div className="d-flex flex-column gap-2">
          <Button
            variant="primary"
            className="btn-custom"
            onClick={() => {
              if (onHide) onHide();
              if (setCurrentStep) setCurrentStep(1);
              navigate('/profile-verify', { state: { revalidationMode: true } });
            }}
          >
            Review My Profile
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RevalidationPromptModal;
